module.exports = __webpack_public_path__ + "static/media/safety-screen.7b7e8375.png";